import { render, staticRenderFns } from "./SteakSVG.vue?vue&type=template&id=858994be&"
import script from "./SteakSVG.vue?vue&type=script&lang=js&"
export * from "./SteakSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports